import React, {Component, Fragment} from 'react';

import {connect} from "react-redux";
import windowSize from "../libs/reactWindowSize";
import {withScenePosition} from "../scenePosition";

import Highlight from "./Highlight";
import Tooltip from "./Tooltip";
import Gif from "./Gif";
import Menu from "./Menu";
// import ComponentRenderer from "./ComponentRenderer";

class Button extends Component {

  constructor(props){
    super(props);

    this.onNextStep = this.onNextStep.bind(this);
  }

  // static getDerivedStateFromProps(props, state){
  //   let { hover, clickable, open, step } = props;
  //
  //   return {
  //     step: step
  //   }
  // }

  onNextStep(){

    let { steps, step, dispatch } = this.props;

    if(step.started) {

      if(step.index + 1 >= step.steps.length) {
        dispatch({
          type: "step/FINISH"
        });
      } else {
        dispatch({
          type: "step/NEXT"
        });
      }
    } else {
      dispatch({
        type: "step/START",
        payload: {
          steps: steps,
          id: this.state.id
        }
      });

      this.setState({
        activated: true
      });
    }
  }

  render() {
    let { left, top, width, height, type} = this.props;
    // const {clickable, open } = this.state;
    const {  onClick, onMouseOver, onMouseOut, steps, highlight, tooltip, gif, menu, showOnHover } = this.props;

    let buttonElement = null;

    let showButtonClass = "";

    if (showOnHover) {
      showButtonClass = "show-button";
    }

    switch(type){
      case "rectangle":
      default:
        buttonElement = (
          <div className={`button rectangle ` + showButtonClass}
               style={{top: top, left: left, width: width, height: height}}
               onMouseOver={onMouseOver}
               onMouseOut={onMouseOut}
               onClick={typeof onClick === "undefined" ? this.onNextStep : onClick} >
          </div>
        );
    }

    return (
      <Fragment>
        {buttonElement}

        {highlight ? (
          <Highlight {...highlight} />
        ) : null}

        {tooltip ? (
          <Tooltip {...tooltip} steps={steps} onNext={(steps)=>this.onNextStep(steps)} onPrevious={this.onPreviousStep} onFinish={this.onFinish} />
        ) : null}

        {gif ? (
          <Gif {...gif}></Gif>
        ) : null}

        {menu ? (
          <Menu {...menu} />
        ) : null}

      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    scene: state.scene,
    step: state.step
  }
}


export default windowSize(connect(mapStateToProps)(withScenePosition(Button)));



// WEBPACK FOOTER //
// ./src/components/Button.jsx